import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FolderIcon from '@mui/icons-material/Folder';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import SubjectIcon from '@mui/icons-material/Subject';
import LinkIcon from '@mui/icons-material/Link';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import TimerIcon from '@mui/icons-material/Timer';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import { CalendarMonth, ContactPage } from '@mui/icons-material';
import { ServiceModuleType, ServiceModuleTypes } from '../../types/serviceModuleTypes';
import { useAppDispatch } from '../../hooks/StoreHooks';
import { createServiceModuleThunk } from '../../store/thunk/serviceModulesThunk';

type ServiceModuleCreatorProps = {
    anchorEl: HTMLElement | null;
    onClose: () => void;
    parentFolderId?: number;
};

const typeToIdMap: Record<string, number> = {
    [ServiceModuleTypes.Calendar]: 1,
    [ServiceModuleTypes.File]: 2,
    [ServiceModuleTypes.Folder]: 3,
    [ServiceModuleTypes.Text]: 4,
    [ServiceModuleTypes.Url]: 5,
    [ServiceModuleTypes.Leaderboard]: 6,
    [ServiceModuleTypes.Timetracking]: 7,
    [ServiceModuleTypes.Absence]: 8,
    [ServiceModuleTypes.PersonalDocuments]: 9,
    [ServiceModuleTypes.StatusSystem]: 10
};

const moduleOptions = [
    { type: ServiceModuleTypes.Calendar, icon: <CalendarMonth />, labelKey: "serviceModulesPage.folderServicePage.addCalendar" },
    { type: ServiceModuleTypes.Folder, icon: <FolderIcon />, labelKey: "serviceModulesPage.folderServicePage.addFolder" },
    { type: ServiceModuleTypes.File, icon: <InsertDriveFileIcon />, labelKey: "serviceModulesPage.folderServicePage.addFile" },
    { type: ServiceModuleTypes.Text, icon: <SubjectIcon />, labelKey: "serviceModulesPage.folderServicePage.addText" },
    { type: ServiceModuleTypes.Url, icon: <LinkIcon />, labelKey: "serviceModulesPage.folderServicePage.addUrl" },
    { type: ServiceModuleTypes.Leaderboard, icon: <LeaderboardIcon />, labelKey: "serviceModulesPage.folderServicePage.addLeaderboard" },
    { type: ServiceModuleTypes.Timetracking, icon: <TimerIcon />, labelKey: "serviceModulesPage.folderServicePage.addTimeTracking" },
    { type: ServiceModuleTypes.Absence, icon: <CalendarMonthIcon />, labelKey: "serviceModulesPage.folderServicePage.addAbsence" },
    { type: ServiceModuleTypes.PersonalDocuments,icon: <ContactPage />, labelKey: "serviceModulesPage.folderServicePage.addPersonalDocuments" },
    { type: ServiceModuleTypes.StatusSystem, icon: <MilitaryTechIcon />, labelKey: "serviceModulesPage.folderServicePage.addStatus" },
];

const ServiceModuleCreator = ({ anchorEl, onClose, parentFolderId }: ServiceModuleCreatorProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [isCreating, setIsCreating] = useState(false);

    const handleCreate = async (type: ServiceModuleType) => {
        if (isCreating) return;
        setIsCreating(true);
        try {
            await dispatch(createServiceModuleThunk({
                serviceModuleType: typeToIdMap[type],
                parentFolderServiceModuleId: parentFolderId,
            }));
            onClose();
        } finally {
            setIsCreating(false);
        }
    };

    return (
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
            {moduleOptions.map(({ type, icon, labelKey }) => (
                <MenuItem key={type} onClick={() => handleCreate(type)} disabled={isCreating}>
                    <ListItemIcon>{icon}</ListItemIcon>
                    <ListItemText>{t(labelKey)}</ListItemText>
                </MenuItem>
            ))}
        </Menu>
    );
};

export default ServiceModuleCreator;
